<template>
    <div class="c-button" v-bind="$attrs" v-on="$listeners">
        <div class="icon">
            <img src="@/assets/image/button/add.svg" />
        </div>
        <div class="text">{{ Text }}</div>
    </div>
</template>
<script>
export default {
    name: "Close",
    props: {
        text: {
            type: String,
        }
    },
    computed: {
        Text() {
            if (!this.text) {
                return this.$t('buttons.back')
            }
            return text
        }
    }
}
</script>
<style lang="scss" scoped>
.c-button {
    position: relative;
    display: inline-block;
    height: 32px;
    background: rgba(222, 134, 143, 0.36);
    box-sizing: border-box;
    padding: 0 12px;

    font-weight: 500;
    border-radius: 3px;
    text-align: center;
    cursor: pointer;

    &:active {
        background: rgba(222, 134, 143, 0.6);
        color: rgb(64, 158, 255);
        background: rgba(222, 134, 143, 0.6);
    }

    .icon {
        position: relative;
        display: inline-block;
        width: 16px;
        height: 32px;

        img {
            position: absolute;
            width: 16px;
            height: 16px;
            top: 50%;
            transform: translateY(-50%);
            left: 0px;
        }
    }

    .text {
        display: inline-block;
        height: 32px;
        vertical-align: top;
        line-height: 32px;
        margin-left: 8px;
    }
}
</style>